import Vue from "vue";
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        online: !!sessionStorage.getItem("TranToken"),
        userName: sessionStorage.getItem("TranName"),
    },
    mutations: {
        setOnline(state) {
            state.online = !!sessionStorage.getItem("TranToken");
        },
        setUserName(state, user) {
            state.userName = user;
        }
    }
})